export default __webpack_public_path__ + "static/media/jetstar-secondary.6cfd0fe7.svg";